import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from 'rxjs';
import {WsAbstraction, WsService} from '../../services/ws.service';
import {ConfigAndResult, PoiGitWebsocketFromClient, PoiGitWebsocketToClient} from './poi-git-models';
import {PoigitService} from './poigit.service';
import {ToastrService} from 'ngx-toastr';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-poi-git',
    templateUrl: './poi-git.component.html',
    styleUrls: ['./poi-git.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class PoiGitComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();
  private wsAbstraction: WsAbstraction<PoiGitWebsocketFromClient, PoiGitWebsocketToClient>;

  data: ConfigAndResult[] = [];
  displayOnlyOurs = localStorage.getItem('poi-git-displayOnlyOurs') === 'true';
  hideBranches = localStorage.getItem('poi-git-hideBranches') !== 'false';

  displaySettings: ({ display: boolean; name: string; key: string })[] = [];

  saveSettings() {
    localStorage.setItem('poi-git-displayOnlyOurs', this.displayOnlyOurs.toString());
    localStorage.setItem('poi-git-hideBranches', this.hideBranches.toString());
    const displaySettingsState = this.displaySettings.map(it => ({key: it.key, display: it.display}));
    localStorage.setItem('poi-git-displaySettings', JSON.stringify(displaySettingsState));
  }


  constructor(
    private wsService: WsService,
    private poigitService: PoigitService,
    private notificationService: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.wsAbstraction = this.wsService.setUpWs<PoiGitWebsocketFromClient, PoiGitWebsocketToClient>('/wsocket/poiGit');
    this.subscriptions.add(
      this.wsAbstraction.read().subscribe((res: PoiGitWebsocketToClient) => {
        console.info('per ws received', res);
        this.loadData(false);
      }));

    this.loadData(true);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getActiveDisplayValues() {
    return this.displaySettings.filter(it => it.display);
  }

  private loadData(initial: boolean) {
    this.poigitService.getPoiGitStatus().subscribe({
      next: res => {
        this.data = res;
      },
      error: err => {
        console.error('failed to load poi-git data', err);
        this.notificationService.error('failed to load data ' + err);
      }
    });

    if (initial) {
      this.poigitService.getPoiGitMetrics().subscribe({
        next: res => {
          const savedSettings = localStorage.getItem('poi-git-displaySettings');
          if (savedSettings) {
            const parsedSettings: { key: string, display: boolean }[] = JSON.parse(savedSettings);
            res.forEach(metric => {
              const saved = parsedSettings.find(s => s.key === metric.key);
              if (saved) {
                metric.display = saved.display;
              }
            });
          }
          this.displaySettings = res;
        },
        error: err => {
          console.error('failed to load poi-git metric metadata', err);
          this.notificationService.error('failed to load data ' + err);
        }
      });
    }
  }

  getFilteredRows() {
    return this.data.filter(row => this.filterApplies(row));
  }

  private filterApplies(row: ConfigAndResult) {
    if (this.displayOnlyOurs && !row.config.ours) {
      return false;
    }
    if (this.hideBranches && row.config.branch) {
      return false;
    }
    return true;
  }

  getMetric(row: ConfigAndResult, metricType: string) {
    return row.result.metricResults.find(mr => mr.metric === metricType)?.result;
  }
}
